import React, { useState, useEffect, useContext } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CustomTextField from "components/FormFields/CustomTextField";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingButton from "./LoadingButton";
import { SignUpPathEnum } from "constants/signUpPath";
import GoogleAutocomplateBusiness from "components/FormFields/GoogleAutocomplateBusiness";
import { FormContext } from "context/formContext";
import { StyledFooterBox, StyledTitle } from "./styles";
import { useGenerateCountQuery } from "api";

const initialDataModel = {
  name: "",
  // lastName: "",
  restaurantName: "",
};

const formSchema = yup.object().shape({
  name: yup.string().required("This field is required"),
  // lastName: yup.string().required("This field is required"),
  restaurantName: yup.string().required("This field is required"),
});

const NameInfo = () => {
  const { updateFormData } = useContext(FormContext);
  const { data } = useGenerateCountQuery();
  const navigate = useNavigate();
  const location = useLocation();

  const formMethods = useForm({
    mode: "all",
    defaultValues: initialDataModel,
    resolver: yupResolver(formSchema),
  });
  const {
    formState: { isSubmitted },
    reset,
    getValues,
  } = formMethods;
  const currentModel = getValues();

  const handleSubmit = async (data) => {
    updateFormData(data);
    navigate(SignUpPathEnum.BUSINESS_INFO);
  };

  useEffect(() => {
    const dataFromStorage = localStorage.getItem("formData");
    const parsedData = JSON.parse(dataFromStorage);
    if (parsedData) {
      reset(parsedData);
    }
  }, [location]);

  const onChangeRestaurantNameInput = (value) => {
    formMethods.setValue("restaurantName", value || "");
  };

  const getBusinessAddressFields = (data) => {
    reset({
      ...getValues(),
      restaurantName: data.name,
      addressInfo: data.addressInfo,
    });
    // setShowData(true);
  };

  const hanldeInvalidSubmit = (errr) => {
    console.log("errr", errr);
  };

  const formatNumber = (number, locale = "en-US") => {
    return new Intl.NumberFormat(locale).format(number);
  };

  return (
    <Grid container justifyContent="center" alignContent={"center"}>
      <Grid item xs={12} md={12} lg={12} sm={12} sx={{}}>
        <Box sx={{ mb: 8 }}>
          <StyledTitle>Let’s Get Started</StyledTitle>
          <StyledTitle
            sx={{
              fontSize: "20px",
              color: "#5a5a5acf",
              height: "20px",
            }}
          >
            {data?.generatedCount
              ? `${formatNumber(
                  data?.generatedCount || 0
                )} AI Generated Websites`
              : ""}
          </StyledTitle>
        </Box>
        <FormProvider {...formMethods}>
          <form
            onSubmit={formMethods.handleSubmit(
              handleSubmit,
              hanldeInvalidSubmit
            )}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                // maxWidth: "453px",
              }}
            >
              <CustomTextField
                placeholder={"Enter Your Name"}
                label="Your Name"
                name="name"
              />

              <GoogleAutocomplateBusiness
                getAddressFields={getBusinessAddressFields}
                onChangeInput={onChangeRestaurantNameInput}
                inputValue={currentModel.restaurantName || ""}
                initialValue={currentModel.restaurantName || ""}
                name="restaurantName"
                label="Restaurant Name"
                required={true}
                formSubmitted={isSubmitted}
                placeholder="Enter Your Restaurant Name"
              />
            </Box>
            <StyledFooterBox sx={{ boxShadow: 4 }}>
              <Grid container m-0 p-0>
                <Grid item lg={6} md={12} xs={12} sm={12} m-0 p-0></Grid>
                <Grid item lg={6} md={12} xs={12} sm={12} m-0 p-0>
                  <Button variant="contained" type="submit">
                    Next
                  </Button>
                </Grid>
              </Grid>
            </StyledFooterBox>
          </form>
        </FormProvider>
      </Grid>
    </Grid>
  );
};

export default NameInfo;
